module.exports = __webpack_public_path__ + "static/media/room4_2.d81ddf82.JPG";